"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.abnOptional = exports.ABN_MATCHES = exports.ABN_LENGTH = void 0;
const yup = __importStar(require("yup"));
exports.ABN_LENGTH = "ABN should be 11 digits long. Alternatively, you can leave this field blank.";
exports.ABN_MATCHES = "ABN should only contain numbers without spaces. Alternatively, you can leave this field blank.";
exports.abnOptional = yup.string()
    .test("ABN only contains digits", exports.ABN_MATCHES, (value) => {
    if (!value)
        return true;
    return /^\d*$/.test(value);
})
    .test("ABN length is 11 digits", exports.ABN_LENGTH, (value) => {
    if (!value)
        return true;
    return value.length === 11;
});
//# sourceMappingURL=Abn.js.map